(function (module) {
    'use strict';

    /**
     * formly type `cssHideInput` — a number input that hides itself with CSS
     * (a display:none class) instead of angular-formly's default `ng-if` hide.
     *
     * Why: angular-formly 8.4.1 has a re-render desync — a field hidden by
     * `hideExpression` (ng-if) at first render is removed from the DOM and NOT
     * re-inserted when the condition later becomes false (formly reports
     * hide=false but the field is absent). The Achievers/Workday "amount" input
     * (limitValue), hidden while "Limit by" is No limit, hit this: it never
     * reappeared when the user chose Days/Count. (Found on stage 2026-07-22.)
     *
     * This type stays mounted and toggles a `formly-css-hidden` class from
     * `templateOptions.cssHide`, so it cannot desync. A global
     * `defaultHideDirective = 'ng-show'` would have fixed it too, but that keeps
     * ALL hidden fields mounted — which breaks custom-app Active Corners (hidden
     * required formlyGeolocation fields would keep the form invalid and fire a
     * location prompt). Scoping the CSS-hide to this one field avoids that.
     *
     * Validation while hidden: because the input stays mounted, its validators
     * would otherwise keep `$ctrl.form.$invalid` true for a value the user can no
     * longer see (Save is gated purely on form.$invalid), and a stale error is
     * NOT re-evaluated just by disabling/clearing (Angular doesn't re-validate on
     * the visibility flip). So the controller, when the field becomes hidden,
     * clears the value and explicitly resets the control to valid + pristine. The
     * input is also `ng-disabled` while hidden and `ng-messages` renders the
     * field errors when it is visible.
     *
     * The field must NOT set `hideExpression` (that re-introduces the ng-if).
     * Drive visibility with a non-self expression:
     *   expressionProperties: { 'templateOptions.cssHide': "<hide condition>" }
     */
    module.config(['formlyConfigProvider', (formlyConfigProvider) => {
        formlyConfigProvider.setType({
            name: 'cssHideInput',
            controller: ['$scope', function ($scope) {
                // When the field becomes hidden, drop its value and force the
                // control valid + pristine so a value the user can no longer see
                // (e.g. an out-of-range or non-numeric entry) cannot keep the form
                // invalid and block Save.
                $scope.$watch('to.cssHide', (isHidden) => {
                    if (!isHidden || !$scope.fc) {
                        return;
                    }
                    $scope.model[$scope.options.key] = undefined;
                    if (typeof $scope.fc.$setViewValue === 'function') {
                        $scope.fc.$setViewValue(undefined);
                        $scope.fc.$render();
                    }
                    angular.forEach($scope.fc.$error, (invalid, key) => {
                        $scope.fc.$setValidity(key, true);
                    });
                    $scope.fc.$setPristine();
                });
            }],
            template:
                '<md-input-container class="md-block" ng-class="{ \'formly-css-hidden\': to.cssHide }">' +
                '<label>{{ to.label }}</label>' +
                '<input name="{{ id }}"' +
                ' type="{{ to.type || \'number\' }}"' +
                ' ng-model="model[options.key]"' +
                ' min="{{ to.min }}"' +
                ' max="{{ to.max }}"' +
                ' step="{{ to.step }}"' +
                ' ng-disabled="to.cssHide"' +
                ' ng-required="!to.cssHide && to.required" />' +
                '<div ng-messages="fc.$error" role="alert" ng-if="!to.cssHide">' +
                '<div ng-message="required">This field is required.</div>' +
                '<div ng-message="min">Enter a number of {{ to.min }} or more.</div>' +
                '<div ng-message="max">Enter a number of {{ to.max }} or less.</div>' +
                '<div ng-message="number">Enter a valid number.</div>' +
                '<div ng-message="step">Enter a valid whole number.</div>' +
                '</div>' +
                '</md-input-container>',
        });
    }]);
})(angular.module('rocket.components'));
